import {useEffect, useState, useRef} from 'react'
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, InfoCircleOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space, Tooltip} from 'antd';
import {getAll, drop} from '../../../../apis/MovimientoCompanyApi';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Catálogos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Movimientos Compañia</span>
      </>
    ),
}];

const SaldosEmpleado = () => {
    const [items, setItems] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [objectSelected, setobjectSelected] = useState(null);
    const [loading, setLoading] = useState(true);    
    const columns = [
      {
        title: 'Clave Concepto',
        dataIndex: 'concepto',
        key: 'concepto',
        render: (item, object)=> {
          return <Space>({item.clave}) {item.descripcion}</Space>
        }
      },
            {
        title: 'Analitica',
        dataIndex: 'analitica_name',
        key: 'analitica',
      },
      {
        title: 'Monto',
        dataIndex: 'monto',
        key: 'monto',
        render: (item, object)=> {
          return <Space>
          {item}
          <Tooltip title={'_compania_monto'}>
            <InfoCircleOutlined />
          </Tooltip>
        </Space>
        }
      },
      {
        title: 'Exento',
        dataIndex: 'exento',
        key: 'exento',
        render: (item, object)=> {
          return <Space>
          {item}
          <Tooltip title={'_compania_exento'}>
            <InfoCircleOutlined />
          </Tooltip>
        </Space>
        }
      },
      {
        title: 'Dias',
        dataIndex: 'dias',
        key: 'dias',
        render: (item, object)=> {
          return <Space>
          {item}
          <Tooltip title={'_compania_dias'}>
            <InfoCircleOutlined />
          </Tooltip>
        </Space>
        }
      },
      {
        title: 'Horas',
        dataIndex: 'horas',
        key: 'horas',
        render: (item, object)=> {
          return <Space>
          {item}
          <Tooltip title={'_compania_horas'}>
            <InfoCircleOutlined />
          </Tooltip>
        </Space>
        }
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          return <Space>
          <Button type='primary' size='small' onClick={()=>{
              openDetails(object);
          }}>Editar</Button>
          <Button type='primary' size='small' danger onClick={()=>{
              deleteConfirm(object);
          }}>Eliminar</Button>
        </Space>
        }
      }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setobjectSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar la movimiento?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('¡El movimiento ha sido eliminado!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setobjectSelected(null);
    }

    const onHandlerFinish = async (refresh) => {
      setOpenEdit(false);
      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }

      setLoading(false);
    }

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    return <PageApp routes={routes}>
      <Button type="primary" onClick={btnClick}>
          Agregar Movimiento
      </Button>
      <Divider/>
      {
          loading ? (
            <p>Loading...</p>
          ) : <>
            {
              items.length == 0 ? <Empty />:
              <Table dataSource={items} columns={columns} />
            }
          </>
      }
      {
        (openEdit && objectSelected && objectSelected.id > 0) &&
        <ModalEdit title={"Editar Movimiento"} id={objectSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !objectSelected) &&
        <ModalEdit title={"Crear Movimiento"} open={openEdit} finish={onHandlerFinish}/>
      }
    </PageApp>
}   

export default SaldosEmpleado;
